import MethodActionGenerator from './MethodActionGenerator'

export default class UpdateActionGenerator extends MethodActionGenerator {
  constructor(name, basePath, parameterName) {
    super('UPDATE', name, basePath, parameterName)
  }

  mainActionGenerator = () => {
    return (id, attributes) => (dispatch) => {
      dispatch({ type: this.types.request, id, attributes })

      return this.client.put(`${this.urlWithParams(attributes)}/${id}`, { [this.parameterName]: attributes })
        .then((response) => {
          return dispatch({
            type: this.types.response,
            id: response.data.id,
            responseHeaders: response.headers
          })
        })
        .catch((error) => dispatch({ type: this.types.error, ...this.parseError(error) }))
    }
  }
}
